import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { Accent, SectionHeading } from './SectionHeading';
import { TeachingFlow } from './TeachingFlow';
import { afterSystem, beforeSystem, systemFlow } from '../../data/content';
export function TransformationSection() {
  return <section aria-labelledby="transformation-heading" className="bg-brand-lavender px-5 py-16 lg:px-8 lg:py-24" data-id="element-214" data-mp="3q5hlman7j5ht">
      <div className="mx-auto max-w-5xl" data-id="element-215" data-mp="3b7yy1bm9myby">
        <SectionHeading id="transformation-heading" title={<>
              From Makeup Artist Who Teaches…
              <span className="block" data-id="element-217" data-mp="32824owoxlbak">
                <Accent data-id="element-218" data-mp="3293phsvr1c5h">To Makeup Educator With a System.</Accent>
              </span>
            </>} data-id="element-216" data-mp="3b75o61s0fspl" />

        <div className="mt-14 grid items-stretch gap-6 md:grid-cols-2" data-id="element-219" data-mp="377586cp9j9gf">
          <div className="rounded-[20px] border border-brand-charcoal/12 bg-white/60 px-6 py-8 sm:px-8" data-id="element-220" data-mp="10hqpni8n1uga">
            <p className="font-body text-[11px] font-semibold uppercase tracking-[0.18em] text-brand-charcoal/50" data-id="element-221" data-mp="15f0aslozvjyb">
              Before
            </p>
            <ul className="mt-6 space-y-3.5" role="list" data-id="element-222" data-mp="iusbwyynjlmk">
              {beforeSystem.map(item => <li key={item} className="flex items-start gap-3 text-[15px] leading-snug text-brand-charcoal/60" data-id="element-223" data-mp="wlnpgok3iqwh">
                  <XIcon className="mt-0.5 h-4 w-4 flex-none text-brand-charcoal/35" strokeWidth={2} aria-hidden="true" data-id="element-224" data-mp="rmkkt5812mp1" />
                  {item}
                </li>)}
            </ul>
          </div>

          <div className="rounded-[20px] bg-brand-plum-dark px-6 py-8 text-white shadow-[0_30px_60px_-30px_rgba(59,27,87,0.7)] sm:px-8" data-id="element-225" data-mp="3w2dmvzf9fmz1">
            <p className="font-body text-[11px] font-semibold uppercase tracking-[0.18em] text-brand-lilac" data-id="element-226" data-mp="dtctzfrrtv8e">After</p>
            <ul className="mt-6 space-y-3.5" role="list" data-id="element-227" data-mp="1pam8dnw1lx2u">
              {afterSystem.map(item => <li key={item} className="flex items-start gap-3 text-[15px] font-medium leading-snug text-white" data-id="element-228" data-mp="1kbrt2vxaaqnh">
                  <span className="mt-0.5 flex h-4 w-4 flex-none items-center justify-center rounded-full bg-white/20" data-id="element-229" data-mp="1scqrxwx7639r">
                    <CheckIcon className="h-3 w-3 text-white" strokeWidth={3} aria-hidden="true" data-id="element-230" data-mp="1wcrd00esxcps" />
                  </span>
                  {item}
                </li>)}
            </ul>
          </div>
        </div>

        <div className="mx-auto mt-14 max-w-3xl rounded-[20px] bg-white px-6 py-8 text-center" data-id="element-231" data-mp="26b7628xe2w1x">
          <TeachingFlow steps={systemFlow} size="lg" data-id="element-232" data-mp="18q1fncdee6bi" />
          <p className="mx-auto mt-5 max-w-xl text-[15px] leading-relaxed text-brand-charcoal/70" data-id="element-233" data-mp="1dmjj88wzrym9">
            These six stages are the six core volumes. Each volume does one job in your teaching workflow —
            from what you know to how you run your classes.
          </p>
        </div>
      </div>
    </section>;
}